import _createForOfIteratorHelper from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _toConsumableArray from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.at.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.at-alternative.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { queryPickType, queryPick, queryPickByDetails, queryByNameAllUser } from '@/api/commonApi.js';
import { Empty } from 'ant-design-vue';
export default {
  name: 'index',
  data: function data() {
    return {
      options: [],
      // 级联选择数据
      cascaderVal: [],
      // 所属部门选择
      userInfo: this.$hdk.userInfo.get(),
      organAndPostKey: 'organ-cascader-value',
      fetching: false,
      allValue: [],
      allUserList: [],
      // 所有用户数据
      modeSwitch: false,
      // 默认模式
      testValue: '',
      showLoading: false,
      //搜索学员加载动画
      searchUserList: [],
      //分页加载搜索到的学员数据
      searchUserAllList: [],
      //搜索到的全部学员数据
      showSearchUser: false,
      //是否显示学员搜索的下拉框
      autoExpandParent: true,
      //是否显示学员搜索的下拉框
      testTree: undefined,
      //组织树绑定已勾选的数据
      disValue: this.disabled,
      //选人组件是否只读状态
      pageSearch: 1,
      //搜索到的学员数据分页页码
      searchData: [],
      //右侧搜索到已选的分页数据
      searchAllData: [],
      //右侧搜索到已选的分页全部数据
      showSearch: false,
      selectedKeys: [],
      showJobLoading: false,
      jobNum: 0,
      //已选岗位数量
      userNum: 0,
      //已选成员数量
      deptNum: 0,
      //已选组织数量
      jobFlag: false,
      userFlag: false,
      deptFlag: false,
      showModal: false,
      //是否打开选人弹窗
      treeData: [],
      //组织组织结构数据
      pickObj: {
        businessId: this.businessId,
        itemize: '',
        // tab默认选中成员
        organId: this.organId,
        postId: this.postId
      },
      pickUserObj: {
        itemize: '',
        // tab默认选中成员
        organId: '',
        typeId: '',
        postId: '',
        postIds: []
      },
      searchObj: {
        limit: 7000,
        page: 1,
        query: ''
      },
      selectData: [],
      //触底节流加载已选数据
      allSelectData: [],
      //全部已选数据
      showSelectData: [],
      //触底节流加载确定选择的人员数据
      userData: [],
      //触底节流加载组织人员数据
      allUserData: [],
      //组织全部人员数据
      allJobUserData: [],
      //岗位全部人员数据
      jobList: [],
      //岗位数据列表
      postData: [],
      //触底节点加载岗位人员数据
      allJobData: [],
      //岗位全部人员数据
      isAllChecked: false,
      //组织人员是否全选
      isJobAllChecked: false,
      //岗位人员是否全选
      showTree: false,
      //组织组织结构加载动画
      showUser: false,
      //组织人员数据加载动画
      showJobUser: false,
      //岗位的成员数据加载动画
      pageDept: 1,
      //组织人员
      pageSelect: 1,
      //已选择人员
      pageJob: 1,
      //岗位人员
      pageSure: 1,
      //已确定人员
      defaultKey: [],
      //组织组织结构默认展开第一层
      textName: '已选',
      //默认‘已选’，搜索时变为‘搜索到’
      activeJob: [],
      //岗位左侧菜单默认置空选中
      pageAll: 1,
      tabList: [],
      selectAllData: [],
      organizationExpandedKeys: [],
      organizationAutoExpandParent: true,
      searchValue: '',
      organizationDataList: [],
      organizationSelectedKeys: [],
      isAllJobChecked: false,
      chooseJobUserList: [],
      chooseJobList: [],
      showJobUserLoading: false
    };
  },
  watch: {
    testValue: function testValue(nData) {
      if (nData === '') {
        this.showSearch = false;
        this.textName = '已选';
      }
    },
    value: {
      handler: function handler(val) {
        this.dataEcho();
      },
      deep: true
    }
  },
  created: function created() {
    var dataEcho = this.dataEcho,
      getPickType = this.getPickType,
      userInfo = this.userInfo;
    dataEcho();
    getPickType();

    // 级联数据处理 
    this.options = _.map(userInfo.organPostTree, function (item) {
      item.postList = _.map(item.postList, function (subItem) {
        return {
          label: subItem.postName,
          value: subItem.postId,
          children: null
        };
      });
      return {
        label: item.organName,
        value: item.organId,
        children: item.postList
      };
    });
  },
  beforeCreate: function beforeCreate() {
    this.simpleImage = Empty.PRESENTED_IMAGE_SIMPLE;
  },
  methods: {
    /**
     * 查询组织类型
     */
    getPickType: function getPickType() {
      var _this = this;
      queryPickType().then(function (res) {
        // this.tabList = res.data.data;
        _this.tabList = _.filter(res.data.data, function (o) {
          return o.itemize === 10003;
        });
        // 数据处理
        if (_this.tabList.length > 0) {
          _.forEach(_this.tabList, function (item) {
            if (item.itemize === 10000) {
              // 组织
              _this.deptFlag = true;
            }
            if (item.itemize === 10002 || item.itemize === 10004) {
              // 岗位
              _this.jobFlag = true;
            }
            if (item.itemize === 10001 || item.itemize === 10003 || item.itemize === 10005) {
              // 成员
              _this.userFlag = true;
            }
          });
        }
      });
    },
    /**
     * 数据回显
     */
    dataEcho: function dataEcho() {
      var _this2 = this;
      var nData = this.value;
      if (nData) {
        // 数据清空
        this.allSelectData = [];
        // 组织数据回显
        if (nData.organData) {
          nData.organData.map(function (item) {
            _this2.allSelectData.push({
              id: item.id,
              name: item.name,
              typeId: item.typeId
            });
          });
        }
        // 岗位数据回显
        if (nData.postData) {
          nData.postData.map(function (item) {
            _this2.allSelectData.push({
              id: item.id,
              name: item.name,
              type: item.type
            });
          });
        }
        // 成员数据回显
        if (nData.userData) {
          nData.userData.map(function (item) {
            _this2.allSelectData.push({
              id: item.id,
              name: item.name,
              type: item.type
            });
          });
        }
        var arr1 = [];
        var arr2 = [];
        var arr3 = [];
        this.allSelectData.forEach(function (item) {
          if (item.type === 1) {
            arr1.push(item);
          } else if (item.type === 2) {
            arr2.push(item);
          } else if (item.type != 1 && item.type != 2) {
            arr3.push(item);
          }
        });
        this.pageSure = 1;
        this.userNum = arr1.length;
        this.jobNum = arr2.length;
        this.deptNum = arr3.length;
        this.showSelectData = this.allSelectData.slice(0, 20);
      }
    },
    /**
     * 搜索条件清空
     */
    testOther: function testOther() {
      if (this.showSearchUser) {
        this.showSearchUser = false;
        this.searchObj.query = '';
      }
    },
    /**
     * 右侧已选择中移除组织
     */
    delDept: function delDept(item) {
      this.pageSelect = 1;
      this.$refs.selectUserBox.scrollTop = 0;
      var dataSource = _toConsumableArray(this.allSelectData);
      this.allSelectData = dataSource.filter(function (items) {
        return items.deptId !== item.deptId;
      });
      this.selectData = this.allSelectData.slice(0, 20);
      var arr = [];
      this.allSelectData.forEach(function (item) {
        if (item.deptId) {
          arr.push(item);
        }
      });
      this.testTree = {
        checked: arr.map(function (item) {
          return item.deptId;
        }),
        halfChecked: []
      };
      if (this.showSearch) {
        var _dataSource = _toConsumableArray(this.searchAllData);
        this.searchAllData = _dataSource.filter(function (items) {
          return items.deptId !== item.deptId;
        });
        this.searchData = this.searchAllData.slice(0, 20);
      }
    },
    /**
     * 接口搜索人员
     */
    handleSearch: function handleSearch(value) {
      if (value) {
        this.showSearchUser = true;
        this.searchObj.query = value;
        // this.showLoading = true;
        // getUserByType(this.searchObj).then(res => {
        //     this.pageAll = 1;
        //     this.searchUserAllList = res.data.map(item => {
        //         let name = '';
        //         if (item.workNo) {
        //             name = item.userName + '(' + item.workNo + ')';
        //         } else {
        //             name = item.userName;
        //         }
        //         return {
        //             userId: item.userId,
        //             userName: name
        //         };
        //     });
        //     this.searchUserList = this.searchUserAllList.slice(0, 20);
        //     this.showLoading = false;
        // });
      } else {
        this.$message.error('请输入搜索条件进行搜索');
      }
    },
    /**
     * tab切换
     */
    changeTab: function changeTab(value) {
      var _this3 = this;
      var $message = this.$message,
        pickObj = this.pickObj;
      if (!pickObj.organId && !pickObj.postId) {
        $message.error('请先选择所属组织及岗位');
        return;
      }
      this.showTree = true;
      queryPick(pickObj).then(function (res) {
        // 处理
        _this3.allUserData = [];
        _this3.allJobUserData = [];
        _this3.userData = [];
        _this3.isAllChecked = false;
        // 树状结构赋值
        _this3.treeData = res.data.data;
        // 如果类型是组织，则第一级进行禁用
        if (pickObj.itemize === 10000) {
          // 组织数据赋值
          if (_this3.allSelectData) {
            _this3.testTree = [];
            for (var i in _this3.allSelectData) {
              ss;
              _this3.testTree.push(_this3.allSelectData[i].id);
            }
          }
        }
        _this3.showTree = false;
        _this3.setNew(res.data.data);
        _this3.$nextTick(function () {
          _this3.generateList(res.data.data);
        });
      });
    },
    /**
     * 搜索已选人员，姓名胸牌号，岗位
     */
    searchUser: function searchUser(value) {
      var arr = _toConsumableArray(this.allSelectData);
      if (value) {
        this.showSearch = true;
        this.textName = '搜索到';
        this.searchAllData = arr.filter(function (item) {
          if (item.name) {
            return item.name.indexOf(value) > -1;
          }
        });
        this.searchData = this.searchAllData.slice(0, 20);
        this.pageSearch = 1;
      } else {
        this.showSearch = false;
        this.textName = '已选';
      }
    },
    /**
     * 选择组织
     */
    onCheck: function onCheck(selectedKeys, info) {
      var arr = info.checkedNodes.map(function (item) {
        return {
          id: item.data.props.id,
          name: item.data.props.title,
          typeId: item.data.props.typeId
        };
      });
      var dataSource = _toConsumableArray(this.allSelectData);
      this.allSelectData = dataSource.filter(function (items) {
        return items.type === 1 && items.type === 2;
      });
      this.pageSelect = 1;
      this.$refs.selectUserBox.scrollTop = 0;
      this.allSelectData = this.allSelectData.concat(_.uniqBy(arr, 'id'));
      this.selectData = this.allSelectData.slice(0, 20);
    },
    /**
     * 选择组织全选
     */
    onSelectAll: function onSelectAll(selectedKeys, info) {
      var _this4 = this;
      var newTestTree = [];
      if (info.selected) {
        var treeData = [info.node.dataRef];
        var newArrData = this.getAllNode(treeData);
        // 选中值进行push
        newArrData.map(function (item) {
          _this4.selectAllData.push({
            id: item.id,
            name: item.title,
            typeId: item.typeId
          });
        });
        // 获取移除后的选中数据
        _.forEach(this.selectAllData, function (item) {
          newTestTree.push(item.id);
        });
      } else {
        var _treeData = [info.node.dataRef];
        var _newArrData = this.getAllNode(_treeData);
        // 删除取消的数据
        _.forEach(_newArrData, function (item) {
          _.remove(_this4.selectAllData, function (reItem) {
            return item.id == reItem.id;
          });
        });
        // 获取移除后的选中数据
        _.forEach(this.selectAllData, function (item) {
          newTestTree.push(item.id);
        });
      }
      var dataSource = _toConsumableArray(this.allSelectData);
      this.allSelectData = dataSource.filter(function (items) {
        return items.type === 1 && items.type === 2;
      });
      this.pageSelect = 1;
      this.$refs.selectUserBox.scrollTop = 0;
      this.allSelectData = this.allSelectData.concat(_.uniqBy(this.selectAllData, 'id'));
      this.selectData = this.allSelectData.slice(0, 20);
      this.testTree = newTestTree;
    },
    /*
     * 获取数组指定的参数值
     */
    getAllNode: function getAllNode(arr) {
      var arrs = [];
      if (!arr) {
        return;
      }
      var _getChild = function getChild(arr) {
        for (var i = 0; i < arr.length; i++) {
          arrs.push(arr[i]);
          if (arr[i].children && arr[i].children.length > 0) {
            _getChild(arr[i].children);
          }
        }
        return arrs;
      };
      return _getChild(arr);
    },
    /*
     * 获取数组指定的参数值（其他）
     */
    getAllNodeOther: function getAllNodeOther(arr, name, childName) {
      var str = '';
      var arrs = [];
      if (!arr) {
        return;
      }
      if (!name) {
        name = 'id';
      }
      if (!childName) {
        childName = 'children';
      }
      var _getChild2 = function getChild(arr) {
        for (var i = 0; i < arr.length; i++) {
          arrs.push(arr[i][name]);
          if (arr[i][childName] && arr[i][childName].length > 0) {
            _getChild2(arr[i].children);
          }
        }
        return arrs;
      };
      return _getChild2(arr);
    },
    /**
     * 点击组织组织结构节点
     */
    handleTree: function handleTree(selectedKeys, info) {
      var keys = [30000, 20000, 40000, 50000, 60000];
      var $set = this.$set,
        pickUserObj = this.pickUserObj,
        pickObj = this.pickObj;
      this.organizationSelectedKeys = selectedKeys;
      this.chooseJobList = [];
      this.allUserData = [];
      if (!this.showJobUserLoading) {
        $set(pickUserObj, 'postId', '');
        $set(pickUserObj, 'orgs', this.getAllNodeOther([info.node.dataRef]));
        $set(pickUserObj, 'organId', selectedKeys[0]);
        $set(pickUserObj, 'itemize', pickObj.itemize);
        $set(pickUserObj, 'typeId', info.node.$options.propsData.dataRef.typeId);
        if (_.filter(keys, function (o) {
          return o === selectedKeys[0];
        }).length === 0) {
          //最顶级默认不查询 
          var str = "10000,10001,10002,10004"; // 10003,10005
          // 如果是“组织、组织成员、组织岗位、岗位”类型处理成成员数据
          if (str.indexOf(pickObj.itemize) != -1) {
            this.getPickByDetails(1);
          } else {
            this.getPickByDetails(2);
          }
        }
      }
    },
    /**
     * 岗位选择
     */
    jobClick: function jobClick(row) {
      var $set = this.$set,
        pickUserObj = this.pickUserObj;
      this.chooseJobList.push(row.id);
      if (!this.showJobUserLoading) {
        $set(pickUserObj, 'postId', row.id);
        $set(pickUserObj, 'organId', row.organId);
        this.getPickByDetails(1);
      }
    },
    /**
     * 岗位成员选择
     */
    jobUserClick: function jobUserClick(row) {
      var $set = this.$set,
        pickUserObj = this.pickUserObj;
      if (!this.showUser) {
        $set(pickUserObj, 'postId', row.id);
        this.getPickByDetails(1);
      }
    },
    /**
     * 根据条件查询岗位或成员
     */
    getPickByDetails: function getPickByDetails(flag) {
      var _this5 = this;
      var pickUserObj = this.pickUserObj;
      if (flag === 1) {
        delete pickUserObj.postId;
        pickUserObj.postIds = this.chooseJobList;
      } else {
        delete pickUserObj.postIds;
      }
      queryPickByDetails(pickUserObj).then(function (res) {
        _this5.pageDept = 1;
        if (res.data.data) {
          if (flag === 1) {
            _this5.showJobUser = true;
            res.data.data = _this5.removedup(res.data.data, 'id');
            _this5.allUserData = res.data.data.map(function (item) {
              return {
                id: item.id,
                name: item.name,
                type: item.type,
                organId: item.organId,
                organName: item.organName,
                disabled: 1
              };
            });
            for (var i = 0; i < _this5.allUserData.length; i++) {
              var tempArr1 = _this5.allUserData[i];
              for (var j = 0; j < _this5.allSelectData.length; j++) {
                var tempArr2 = _this5.allSelectData[j];
                if (tempArr2.id === tempArr1.id) {
                  tempArr1.disabled = 2;
                  break;
                }
              }
            }
            _this5.userData = _this5.allUserData.slice(0, 20);
            setTimeout(function () {
              _this5.showJobUser = false;
            }, 500);
            if (_this5.allUserData.length > 0) {
              _this5.isAllChecked = true;
              var _iterator = _createForOfIteratorHelper(_this5.allUserData),
                _step;
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  var item = _step.value;
                  if (item.disabled != 2) {
                    _this5.isAllChecked = false;
                    return;
                  }
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
            } else {
              _this5.isAllChecked = false;
            }
          } else {
            _this5.showJobUserLoading = true;
            // res.data.data = this.removedup(res.data.data, 'id');
            _this5.allJobUserData = res.data.data.map(function (item) {
              return {
                id: item.id,
                name: item.name,
                type: item.type,
                organId: item.organId,
                organName: item.organName,
                disabled: item.disabled
              };
            });
            for (var _i = 0; _i < _this5.allJobUserData.length; _i++) {
              var _tempArr = _this5.allJobUserData[_i];
              for (var _j = 0; _j < _this5.allSelectData.length; _j++) {
                var _tempArr2 = _this5.allSelectData[_j];
                if (_tempArr2.id === _tempArr.id) {
                  _tempArr.disabled = 2;
                  break;
                }
              }
            }
            _this5.userData = _this5.allJobUserData.slice(0, 20);
            // this.userData = this.allJobUserData

            setTimeout(function () {
              _this5.showJobUserLoading = false;
            }, 500);
            if (_this5.allJobUserData.length > 0) {
              _this5.isAllJobChecked = true;
              var _iterator2 = _createForOfIteratorHelper(_this5.allJobUserData),
                _step2;
              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  var _item = _step2.value;
                  if (_item.disabled != 2) {
                    _this5.isAllJobChecked = false;
                    return;
                  }
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
            } else {
              _this5.isAllJobChecked = false;
            }
          }
        }
      });
    },
    /**
     * 数组去重
     */
    removedup: function removedup(arr, batch) {
      if (!Array.isArray(arr)) {
        return arr;
      }
      if (arr.length == 0) {
        return [];
      }
      var obj = {};
      var uniqueArr = arr.reduce(function (total, item) {
        obj[item[batch]] ? '' : obj[item[batch]] = true && total.push(item);
        return total;
      }, []);
      return uniqueArr;
    },
    /**
     * 点击全选
     */
    handleAll: function handleAll(e) {
      this.pageSelect = 1;
      this.$refs.selectUserBox.scrollTop = 0;
      this.isAllChecked = true;
      if (e.target.checked) {
        var _iterator3 = _createForOfIteratorHelper(this.allUserData),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var item = _step3.value;
            item.disabled = 2;
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
        var _iterator4 = _createForOfIteratorHelper(this.userData),
          _step4;
        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var _item2 = _step4.value;
            _item2.disabled = 2;
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
        var arr = this.allSelectData.concat(this.allUserData);
        var deptArr = [];
        var jobArr = [];
        var userArr = [];
        arr.forEach(function (item) {
          if (item.type === 1) {
            userArr.push(item);
          } else if (item.type === 2) {
            jobArr.push(item);
          } else if (item.type != 1 && item.type != 2) {
            deptArr.push(item);
          }
        });
        var userArrs = this.removedup(userArr, 'id');
        this.chooseJobUserList = userArrs;
        // let arrs = deptArr.concat(jobArr);
        // this.allSelectData = userArrs.concat(arrs);
        this.allSelectData = this.chooseJobUserList;
        this.selectData = this.allSelectData.slice(0, 20);
      } else {
        this.isAllChecked = false;
        var _iterator5 = _createForOfIteratorHelper(this.allUserData),
          _step5;
        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var _item3 = _step5.value;
            _item3.disabled = 1;
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
        var _iterator6 = _createForOfIteratorHelper(this.userData),
          _step6;
        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            var _item4 = _step6.value;
            _item4.disabled = 1;
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }
        this.chooseJobUserList = [];
        var result = [];
        var _iterator7 = _createForOfIteratorHelper(this.allSelectData),
          _step7;
        try {
          for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
            var _item5 = _step7.value;
            var flag = false;
            var _iterator8 = _createForOfIteratorHelper(this.allUserData),
              _step8;
            try {
              for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
                var items = _step8.value;
                if (_item5.id === items.id) {
                  flag = true;
                  break;
                }
              }
            } catch (err) {
              _iterator8.e(err);
            } finally {
              _iterator8.f();
            }
            if (!flag) {
              result.push(_item5);
            }
          }
        } catch (err) {
          _iterator7.e(err);
        } finally {
          _iterator7.f();
        }
        this.allSelectData = result;
        this.selectData = this.allSelectData.slice(0, 20);
      }
    },
    //岗位全选
    JobHandleAll: function JobHandleAll(e) {
      this.pageSelect = 1;
      this.$refs.selectUserBox.scrollTop = 0;
      this.isAllJobChecked = true;
      if (e.target.checked) {
        var _iterator9 = _createForOfIteratorHelper(this.allJobUserData),
          _step9;
        try {
          for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
            var item = _step9.value;
            item.disabled = 2;
            this.chooseJobList.push(item.id);
          }
        } catch (err) {
          _iterator9.e(err);
        } finally {
          _iterator9.f();
        }
        this.getPickByDetails(1);
      } else {
        this.isAllJobChecked = false;
        var _iterator0 = _createForOfIteratorHelper(this.allJobUserData),
          _step0;
        try {
          for (_iterator0.s(); !(_step0 = _iterator0.n()).done;) {
            var _item6 = _step0.value;
            _item6.disabled = 1;
          }
        } catch (err) {
          _iterator0.e(err);
        } finally {
          _iterator0.f();
        }
        this.chooseJobList = [];
        this.allUserData = [];
        var result = [];
        var _iterator1 = _createForOfIteratorHelper(this.allSelectData),
          _step1;
        try {
          for (_iterator1.s(); !(_step1 = _iterator1.n()).done;) {
            var _item7 = _step1.value;
            var flag = false;
            var _iterator10 = _createForOfIteratorHelper(this.allJobUserData),
              _step10;
            try {
              for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
                var items = _step10.value;
                if (_item7.id === items.id) {
                  flag = true;
                  break;
                }
              }
            } catch (err) {
              _iterator10.e(err);
            } finally {
              _iterator10.f();
            }
            if (!flag) {
              result.push(_item7);
            }
          }
        } catch (err) {
          _iterator1.e(err);
        } finally {
          _iterator1.f();
        }
      }
    },
    /**
     * 弹窗外清空已选人员
     */
    clearAll: function clearAll() {
      this.pageSure = 1;
      this.allSelectData = [];
      this.showSelectData = [];
      this.chooseJobList = [];
      this.chooseJobUserList = [];
      this.userNum = 0;
      this.jobNum = 0;
      this.deptNum = 0;
      this.$emit('childValueChange', []);
      var newArr = {};
      this.$emit("input", newArr);
    },
    /**
     * 清空已选人员
     */
    handleClear: function handleClear() {
      var pickObj = this.pickObj;
      this.testTree = undefined;
      this.selectData = [];
      this.allSelectData = [];
      this.isAllJobChecked = false;
      this.chooseJobList = [];
      if (pickObj.itemize == 10001 || pickObj.itemize == 10002 || pickObj.itemize == 10003 || pickObj.itemize == 10004 || pickObj.itemize == 10005) {
        this.isAllChecked = false;
        this.allUserData.forEach(function (item) {
          if (item.disabled === 2) {
            item.disabled = 1;
          }
        });
        this.userData = this.allUserData.slice(0, 20);
      }
      var _iterator11 = _createForOfIteratorHelper(this.allJobUserData),
        _step11;
      try {
        for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
          var item = _step11.value;
          item.disabled = 1;
        }
      } catch (err) {
        _iterator11.e(err);
      } finally {
        _iterator11.f();
      }
      if (pickObj.itemize == 10003) {
        this.isJobAllChecked = false;
        this.allJobData.forEach(function (item) {
          if (item.disabled === 2) {
            item.disabled = 1;
          }
        });
        this.postData = this.allJobData.slice(0, 20);
      }
      this.pageDept = 1;
      if (this.$refs.userbox) {
        this.$refs.userbox.scrollTop = 0;
      }
    },
    /**
     * 选择框里删除人员
     */
    allDelUser: function allDelUser(item) {
      this.userNum = this.userNum - 1;
      this.pageSure = 1;
      this.$refs.sureUser.scrollTop = 0;
      var dataSource = _toConsumableArray(this.allSelectData);
      this.allSelectData = dataSource.filter(function (items) {
        return items.id !== item.id;
      });
      this.showSelectData = this.allSelectData.slice(0, 20);
      var arr = this.allSelectData.map(function (item) {
        return {
          id: item.id,
          name: item.name,
          type: item.type
        };
      });
      this.handleSumbit();
      // this.$emit('childValueChange', arr);
      // 阻止冒泡
      event.stopPropagation();
    },
    /**
     * 选择框里删除岗位
     */
    allDelJob: function allDelJob(item) {
      this.jobNum = this.jobNum - 1;
      this.pageSure = 1;
      this.$refs.sureUser.scrollTop = 0;
      var dataSource = _toConsumableArray(this.allSelectData);
      this.allSelectData = dataSource.filter(function (items) {
        return items.id !== item.id;
      });
      this.showSelectData = this.allSelectData.slice(0, 20);
      var arr = this.allSelectData.map(function (item) {
        return {
          id: item.id,
          name: item.name,
          type: item.type
        };
      });
      this.$emit('childValueChange', arr);
      // 阻止冒泡
      event.stopPropagation();
    },
    /**
     * 选择框里删除组织
     */
    allDelDept: function allDelDept(item) {
      this.deptNum = this.deptNum - 1;
      this.pageSure = 1;
      this.$refs.sureUser.scrollTop = 0;
      var dataSource = _toConsumableArray(this.allSelectData);
      this.allSelectData = dataSource.filter(function (items) {
        return items.id !== item.id;
      });
      this.showSelectData = this.allSelectData.slice(0, 20);
      var arr = this.allSelectData.map(function (item) {
        return {
          id: item.id,
          name: item.name,
          typeId: item.typeId
        };
      });
      this.$emit('childValueChange', arr);
      // 阻止冒泡
      event.stopPropagation();
    },
    /**
     * 移除已选人员
     */
    delUser: function delUser(item) {
      var _this6 = this;
      this.pageSelect = 1;
      this.$refs.selectUserBox.scrollTop = 0;
      var dataSource = _toConsumableArray(this.allSelectData);
      this.allSelectData = dataSource.filter(function (items) {
        return items.id !== item.id;
      });
      this.selectData = this.allSelectData.slice(0, 20);
      this.allUserData.forEach(function (items) {
        if (items.disabled === 1) {
          _this6.isAllChecked = false;
        }
        if (items.id === item.id) {
          items.disabled = 1;
          _this6.isAllChecked = false;
        }
      });
      this.userData.forEach(function (items) {
        if (items.id === item.id) {
          items.disabled = 1;
        }
      });
      if (this.showSearch) {
        var _dataSource2 = _toConsumableArray(this.searchAllData);
        this.searchAllData = _dataSource2.filter(function (items) {
          return items.id !== item.id;
        });
        this.searchData = this.searchAllData.slice(0, 20);
      }
    },
    /**
     * 移除岗位
     */
    delJob: function delJob(item) {
      this.pageSelect = 1;
      this.$refs.selectUserBox.scrollTop = 0;
      var dataSource = _toConsumableArray(this.allSelectData);
      this.allSelectData = dataSource.filter(function (items) {
        return items.id !== item.id;
      });
      this.selectData = this.allSelectData.slice(0, 20);
      this.allJobUserData.forEach(function (items) {
        if (items.id === item.id) {
          items.disabled = 1;
        }
      });
      if (this.showSearch) {
        var _dataSource3 = _toConsumableArray(this.searchAllData);
        this.searchAllData = _dataSource3.filter(function (items) {
          return items.id !== item.id;
        });
        this.searchData = this.searchAllData.slice(0, 20);
      }
    },
    /**
     * 选择组织人员数据触底加载
     */
    getScroll: function getScroll(event) {
      if (this.pageDept === Math.ceil(this.allUserData.length / 20)) {
        return;
      }
      var scrollBottom = event.target.scrollHeight - event.target.scrollTop - event.target.clientHeight;
      if (scrollBottom == 0) {
        var i = 20 * this.pageDept;
        var j = (this.pageDept + 1) * 20;
        this.userData = this.userData.concat(this.allUserData.slice(i, j));
        this.pageDept++;
      }
    },
    /**
     * 已选择人员触底加载
     */
    getScrolls: function getScrolls(event) {
      if (this.pageSelect === Math.ceil(this.allSelectData.length / 20)) {
        return;
      }
      var scrollBottom = event.target.scrollHeight - event.target.scrollTop - event.target.clientHeight;
      if (scrollBottom == 0) {
        var i = 20 * this.pageSelect;
        var j = (this.pageSelect + 1) * 20;
        this.selectData = this.selectData.concat(this.allSelectData.slice(i, j));
        this.pageSelect++;
      }
    },
    /**
     * 搜索到的数据触底加载
     */
    searchs: function searchs(event) {
      if (this.pageSearch === Math.ceil(this.searchAllData.length / 20)) {
        return;
      }
      var scrollBottom = event.target.scrollHeight - event.target.scrollTop - event.target.clientHeight;
      if (scrollBottom == 0) {
        var i = 20 * this.pageSearch;
        var j = (this.pageSearch + 1) * 20;
        this.searchData = this.searchData.concat(this.searchAllData.slice(i, j));
        this.pageSearch++;
      }
    },
    /**
     * 选择岗位人员的触底加载
     */
    getScrollss: function getScrollss(event) {
      if (this.pageJob === Math.ceil(this.allJobData.length / 20)) {
        return;
      }
      var scrollBottom = event.target.scrollHeight - event.target.scrollTop - event.target.clientHeight;
      if (scrollBottom == 0) {
        var i = 20 * this.pageJob;
        var j = (this.pageJob + 1) * 20;
        this.postData = this.postData.concat(this.allJobData.slice(i, j));
        this.pageJob++;
      }
    },
    /**
     * 确定人员的触底加载
     */
    getScrollsss: function getScrollsss(event) {
      if (this.pageSure === Math.ceil(this.allSelectData.length / 20)) {
        return;
      }
      var scrollBottom = event.target.scrollHeight - event.target.scrollTop - event.target.clientHeight;
      if (scrollBottom == 0) {
        var i = 20 * this.pageSure;
        var j = (this.pageSure + 1) * 20;
        this.showSelectData = this.showSelectData.concat(this.allSelectData.slice(i, j));
        this.pageSure++;
      }
    },
    /**
     * 搜索到的人员触底加载
     */
    searchEvent: function searchEvent(event) {
      if (this.pageAll === Math.ceil(this.searchUserAllList.length / 20)) {
        return;
      }
      var scrollBottom = event.target.scrollHeight - event.target.scrollTop - event.target.clientHeight;
      if (scrollBottom == 0) {
        var i = 20 * this.pageAll;
        var j = (this.pageAll + 1) * 20;
        this.searchUserList = this.searchUserList.concat(this.searchUserAllList.slice(i, j));
        this.pageAll++;
      }
    },
    /**
     * 搜索到的人员选择
     */
    searchSelectUser: function searchSelectUser(item) {
      var _iterator12 = _createForOfIteratorHelper(this.allSelectData),
        _step12;
      try {
        for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
          var items = _step12.value;
          if (item.userId === items.userId) {
            this.$message.error('已选择了该人员');
            return;
          }
        }
      } catch (err) {
        _iterator12.e(err);
      } finally {
        _iterator12.f();
      }
      this.pageSelect = 1;
      this.$refs.selectUserBox.scrollTop = 0;
      this.allSelectData.push(item);
      this.selectData = this.allSelectData.slice(0, 20);
    },
    /**
     * 勾选选择人员
     */
    selectUser: function selectUser(item) {
      var _this7 = this;
      this.pageSelect = 1;
      this.$refs.selectUserBox.scrollTop = 0;
      this.isAllChecked = false;
      var _iterator13 = _createForOfIteratorHelper(this.allSelectData),
        _step13;
      try {
        for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
          var items = _step13.value;
          if (items.id === item.id && items.organId === item.organId) {
            item.disabled = 1;
            var dataSource = _toConsumableArray(this.allSelectData);
            this.allSelectData = dataSource.filter(function (itemss) {
              return itemss.id !== item.id;
            });
            this.selectData = this.allSelectData.slice(0, 20);
            return;
          }
        }
      } catch (err) {
        _iterator13.e(err);
      } finally {
        _iterator13.f();
      }
      item.disabled = 2;
      this.allSelectData.push(item);
      this.selectData = this.allSelectData.slice(0, 20);
      this.isAllChecked = true;
      this.allUserData.forEach(function (item) {
        if (item.disabled === 1) {
          _this7.isAllChecked = false;
        }
      });
    },
    /**
     * 勾选岗位
     */
    selectJob: function selectJob(row) {
      var index = this.chooseJobList.findIndex(function (item) {
        return item === row.id;
      });
      if (index != -1) {
        this.chooseJobList.splice(index, 1);
        this.allJobUserData.forEach(function (item) {
          if (item.id === row.id) {
            item.disabled = 1;
          }
        });
        if (this.chooseJobList.length === 0) {
          this.isAllJobChecked = false;
        }
      } else {
        this.isAllJobChecked = false;
        this.chooseJobList.push(row.id);
        this.allJobUserData.forEach(function (item) {
          if (item.id === row.id) {
            item.disabled = 2;
          }
        });
        if (this.chooseJobList.length === this.allJobUserData.length) {
          this.isAllJobChecked = true;
        }
        this.getPickByDetails(1);
      }
    },
    /**
     * 模式切换
     */
    onModeSwitch: function onModeSwitch() {
      if (this.modeSwitch) {
        this.modeSwitch = false;
      } else {
        this.modeSwitch = true;
      }
    },
    /**
     * 查询所有用户
     */
    fetchUser: function fetchUser(value) {
      var _this8 = this;
      if (value) {
        this.fetching = true;
        queryByNameAllUser(value).then(function (res) {
          if (res.data.data) {
            _this8.allUserList = res.data.data;
          }
          _this8.fetching = false;
        });
      } else {
        this.allUserList = [];
      }
    },
    /**
     * 用户选择
     */
    handleChange: function handleChange(value, option) {
      this.allValue = [];
      if (value && value.length > 0) {
        var rowUser = option.at(-1).data.attrs.data;
        // 查询当前选择是否存在
        var isExist = _.find(this.allSelectData, ['id', rowUser.id]);
        if (rowUser && !isExist) {
          this.pageSelect = 1;
          this.$refs.selectUserBox.scrollTop = 0;
          this.allSelectData.push(rowUser);
          this.selectData = this.allSelectData.slice(0, 20);
        } else {
          this.$message.error('该用户已经选择!');
        }
      }
    },
    /**
     * 打开选人弹出层
     */
    handleShow: function handleShow() {
      var $set = this.$set,
        $message = this.$message,
        $storage = this.$storage,
        organAndPostKey = this.organAndPostKey,
        pickObj = this.pickObj,
        businessId = this.businessId,
        changeTab = this.changeTab;
      if (!this.value.organId || !this.value.postId) {
        var needData = JSON.parse(sessionStorage.getItem('needIdData'));
        if (needData) {
          this.value.organId = needData.organId;
          this.value.postId = needData.postId;
        } else {
          $message.error('请选择所属组织及岗位!');
          return;
        }
      }
      // 如果传值为true禁止弹框
      if (this.disabled) {
        return;
      }
      var selectOrganAndPost = $storage.get(organAndPostKey);
      if (this.value && this.value.organId && this.value.postId) {
        this.cascaderVal = [this.value.organId, this.value.postId];
        // 组织岗位赋值
        $set(pickObj, 'organId', this.value.organId);
        $set(pickObj, 'postId', this.value.postId);
        changeTab(this.tabList[0].itemize);
      } else if (selectOrganAndPost) {
        this.cascaderVal = selectOrganAndPost;
        // 组织岗位赋值
        $set(pickObj, 'organId', this.cascaderVal[0]);
        $set(pickObj, 'postId', this.cascaderVal[1]);
        changeTab(this.tabList[0].itemize);
      }
      if (businessId === 0) {
        $message.error('请检查businessId参数是否传入!');
        return;
      }
      $set(pickObj, 'businessId', businessId);
      this.testValue = '';
      this.searchObj.query = '';
      this.showSearchUser = false;
      this.showSearch = false;
      this.textName = '已选';
      this.testTree = undefined;
      this.showModal = true;
      this.showTree = false;
      this.allUserData = [];
      this.chooseJobList = [];
      this.allJobUserData = [];
      this.userData = [];
      this.isAllChecked = false;
      this.selectData = this.allSelectData.slice(0, 20);
      this.pageSelect = 1;
      // 根据传入数据默认获取第1个
      this.pickObj.itemize = this.tabList[0].itemize;
      // changeTab(this.tabList[0].itemize);
      this.organizationExpandedKeys = [];
      changeTab('');
    },
    /**
     * 确定选人数据
     */
    handleSumbit: function handleSumbit() {
      var cascaderVal = this.cascaderVal;
      var arr1 = [];
      var arr2 = [];
      var arr3 = [];
      this.allSelectData.forEach(function (item) {
        if (item.type === 1) {
          arr1.push(item);
        } else if (item.type === 2) {
          arr2.push(item);
        } else {
          arr3.push(item);
        }
      });
      this.pageSure = 1;
      this.showSelectData = this.allSelectData.slice(0, 20);
      this.userNum = arr1.length;
      this.jobNum = arr2.length;
      this.deptNum = arr3.length;
      this.showModal = false;

      // 数据处理
      var newArr = {};
      var userData = [];
      var postData = [];
      var organData = [];
      var arr = this.allSelectData.map(function (item) {
        if (item.type === 1) {
          // 双向绑定需要的数据
          userData.push({
            id: item.id,
            name: item.name,
            type: item.type
          });
          return {
            id: item.id,
            name: item.name,
            type: item.type
          };
        } else if (item.type === 2) {
          // 双向绑定需要的数据
          postData.push({
            id: item.id,
            name: item.name,
            type: item.type
          });
          return {
            id: item.id,
            name: item.name,
            type: item.type
          };
        } else {
          // 双向绑定需要的数据
          organData.push({
            id: item.id,
            name: item.name,
            typeId: item.typeId
          });
          return {
            id: item.id,
            name: item.name,
            typeId: item.typeId
          };
        }
      });

      //  打印已选择的组织、成员、岗位

      // this.$emit('childValueChange', arr);
      newArr.userData = userData;
      newArr.postData = postData;
      newArr.organData = organData;
      // 所属组织和岗位
      newArr.organId = cascaderVal[0];
      newArr.postId = cascaderVal[1];
      this.$emit("input", newArr);
    },
    /**
     * 关闭选人弹出层
     */
    handleCancel: function handleCancel() {
      this.showModal = false;
      this.isAllChecked = false;
      this.selectData = [];
      this.allSelectData = [];
      this.showSelectData = [];
      this.userData = [];
      this.allUserData = [];
      this.postData = [];
      this.showTre = false;
      this.showUser = false;
      this.pageDept = 1;
      this.pageSelect = 1;
      this.deptNum = 0;
      this.userNum = 0;
      this.jobNum = 0;
      var newArr = {};
      this.$emit("input", newArr);
    },
    /**
     * 级联选择
     */
    onOrganAndJob: function onOrganAndJob(value) {
      var $set = this.$set,
        $storage = this.$storage,
        organAndPostKey = this.organAndPostKey,
        cascaderVal = this.cascaderVal,
        pickObj = this.pickObj,
        changeTab = this.changeTab;
      // 存入级联选择的数据 $storage.remove(key)
      $storage.set(organAndPostKey, value);

      // 组织岗位赋值
      $set(pickObj, 'organId', value[0]);
      $set(pickObj, 'postId', value[1]);
      changeTab(this.tabList[0].itemize);
    },
    filterOption: function filterOption(inputValue, path) {
      return path.some(function (option) {
        return option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1;
      }) || path.some(function (option) {
        return option.value.toLowerCase().indexOf(inputValue.toLowerCase()) > -1;
      });
    },
    //选人组件新需求
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    /**
     * 处理组织架构
     */
    setNew: function setNew(data) {
      var scopedSlots = {
        title: 'title'
      };
      var slots = {
        icon: 'meh'
      };
      var _iterator14 = _createForOfIteratorHelper(data),
        _step14;
      try {
        for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
          var i = _step14.value;
          i.scopedSlots = scopedSlots;
          i.disabled = false;
          i.slots = slots;
          if (i.id == '60000') {
            i.title = '教研组织';
          }
          if (i.id == '50000') {
            i.title = '工会组织';
          }
          if (i.id == '40000') {
            i.title = '教学组织';
          }
          if (i.children) {
            this.setNew(i.children);
          }
        }
      } catch (err) {
        _iterator14.e(err);
      } finally {
        _iterator14.f();
      }
      this.treeData = data;
    },
    /**
     * 处理组织架构
     */
    generateList: function generateList(data) {
      for (var i = 0; i < data.length; i++) {
        this.organizationDataList.push({
          id: data[i].id,
          title: data[i].title
        });
        if (data[i].children) {
          this.generateList(data[i].children);
        }
      }
    },
    /**
     * 处理组织架构
     */
    getParentKey: function getParentKey(key, tree) {
      var parentKey;
      for (var i = 0; i < tree.length; i++) {
        var node = tree[i];
        if (node.children) {
          if (node.children.some(function (item) {
            return item.id === key;
          })) {
            parentKey = node.id;
          } else if (this.getParentKey(key, node.children)) {
            parentKey = this.getParentKey(key, node.children);
          }
        }
      }
      return parentKey;
    },
    /**
    * 是否允许展开树形组织架构
    */
    organizationOnExpand: function organizationOnExpand(expandedKeys) {
      this.organizationExpandedKeys = expandedKeys;
      this.organizationAutoExpandParent = false;
    },
    //组织岗位检索
    organizationNameOnSearch: function organizationNameOnSearch(e) {
      var _this9 = this;
      var value = e;
      var organizationExpandedKeys = this.organizationDataList.map(function (item) {
        if (item.title.indexOf(value) > -1) {
          return _this9.getParentKey(item.id, _this9.treeData);
        }
        return null;
      }).filter(function (item, i, self) {
        return item && self.indexOf(item) === i;
      });
      Object.assign(this, {
        organizationExpandedKeys: organizationExpandedKeys,
        searchValue: value,
        organizationAutoExpandParent: true
      });
    },
    //岗位检索
    organizationJobNameOnSearch: function organizationJobNameOnSearch(value, event) {
      if (value) {
        var jobFilterList = this.allJobUserData && this.allJobUserData.length ? this.allJobUserData.filter(function (item) {
          return item.name.indexOf(value) !== -1;
        }) : [];
        this.allJobUserData = jobFilterList;
      } else {
        this.pickUserObj.postId = '';
        this.pickUserObj.organId = this.organizationSelectedKeys[0];
        this.organizationExpandedKeys = this.organizationSelectedKeys;
        this.organizationAutoExpandParent = true;
        this.getPickByDetails(2);
      }
    },
    //岗位下的人员检索
    organizationManNameOnSearch: function organizationManNameOnSearch(value, event) {
      if (value) {
        var filterList = this.allUserData && this.allUserData.length ? this.allUserData.filter(function (item) {
          return item.name.indexOf(value) !== -1;
        }) : [];
        this.allUserData = filterList;
      } else {
        this.getPickByDetails(1);
      }
    }
  },
  props: {
    value: {
      type: Object,
      default: function _default() {}
    },
    disabled: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '300px'
    },
    height: {
      type: String,
      default: '80px'
    },
    businessId: {
      type: Number,
      default: 0
    }
  }
};